(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-video-display"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lara-dynamic-video-display')) {
    customElements.define('lara-dynamic-video-display', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.hideWhenStacked !== 'true') return;
        this.frame = requestAnimationFrame(() => this.start());
      }

      start() {
        if (!this.isConnected) return;
        this.layout = this.querySelector('.dvd__layout');
        this.media = this.querySelector('.dvd__media');
        if (!this.layout || !this.media || !this.querySelector('.dvd__content')) return;

        this.scheduleUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateLayout());
        };

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.scheduleUpdate);
          this.observer.observe(this.layout);
          this.observer.observe(this.media);
        }
        window.addEventListener('resize', this.scheduleUpdate, { passive: true });
        this.updateLayout();
      }

      updateLayout() {
        if (!this.isConnected) return;
        const layoutStyle = getComputedStyle(this.layout);
        const availableWidth = parseFloat(layoutStyle.width);
        const mediaWidth = parseFloat(getComputedStyle(this.media).width);
        const textMinimum = parseFloat(getComputedStyle(this).getPropertyValue('--dvd-text-min')) || 320;
        const gap = parseFloat(layoutStyle.columnGap) || 0;

        if (!(availableWidth > 0) || !Number.isFinite(mediaWidth)) return;

        // Media sizing does not grow to fill the space released by hidden text.
        // We test the space the text WOULD need, even while it is display:none.
        // This avoids alternating visible/hidden states on each measurement.
        const fits = availableWidth + 0.01 >= mediaWidth + gap + textMinimum;
        const nextLayout = fits ? 'row' : 'stacked';
        if (this.dataset.layout !== nextLayout) this.dataset.layout = nextLayout;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.scheduleUpdate) window.removeEventListener('resize', this.scheduleUpdate);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
